import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { getBottomNavItems, getActivePrimaryNav } from '@/config/navigation';

export const BottomNavigation: React.FC = () => {
  const location = useLocation();
  const navItems = getBottomNavItems();
  const activeKey = getActivePrimaryNav(location.pathname, navItems);

  return (
    <nav aria-label="Primary" className="w-full lg:hidden">
      <div className="border-t border-white/70 bg-[#fffaf4]/96 shadow-[0_-6px_20px_rgba(15,23,42,0.06)] backdrop-blur-xl supports-[backdrop-filter]:bg-[#fffaf4]/90 sm:rounded-t-[28px] sm:border sm:border-white/75 sm:px-4 sm:pb-3 sm:pt-2 sm:shadow-[0_14px_32px_rgba(15,23,42,0.10),0_2px_10px_rgba(15,23,42,0.05)]">
        <div className="flex items-stretch gap-1 px-2 pt-2 sm:gap-1.5 sm:px-2 sm:pt-0" style={{ paddingBottom: 'calc(env(safe-area-inset-bottom, 0px) + 0.5rem)' }}>
          {navItems.map((item) => {
            const Icon = item.icon;
            const isActive = activeKey === item.key;

            return (
              <NavLink
                key={item.key}
                to={item.href}
                aria-current={isActive ? 'page' : undefined}
                className={`group flex min-h-[64px] min-w-0 flex-1 flex-col items-center justify-center rounded-[18px] px-1 py-2 text-center text-[11px] font-medium tracking-[0.01em] transition-[transform,color,background-color] duration-200 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange-500 focus-visible:ring-offset-2 active:scale-[0.98] sm:min-h-[68px] sm:rounded-[22px] sm:px-1.5 sm:py-2 ${
                  isActive ? 'text-orange-700' : 'text-slate-500 hover:text-slate-700'
                }`}
              >
                <span
                  className={`mb-1.5 flex h-9 w-9 items-center justify-center rounded-full transition-all duration-200 sm:h-10 sm:w-10 ${
                    isActive
                      ? 'bg-orange-100/90 text-orange-700 shadow-[inset_0_1px_0_rgba(255,255,255,0.55),0_4px_12px_rgba(251,146,60,0.16)]'
                      : 'text-slate-500 group-hover:bg-white/80 group-hover:text-slate-700 group-active:bg-white'
                  }`}
                >
                  <Icon className={`h-[18px] w-[18px] shrink-0 sm:h-[19px] sm:w-[19px] ${isActive ? 'stroke-[2.25]' : 'stroke-[2]'} `} />
                </span>
                <span className={`truncate leading-none ${isActive ? 'font-semibold' : 'font-medium'}`}>{item.label}</span>
              </NavLink>
            );
          })}
        </div>
      </div>
    </nav>
  );
};
